import React, { Component } from "react";
import {
  Wrapper,
  Card,
  Title,
  Copy,
  Bold,
  Row,
  Button,
  Icon,
  ModalOverlay,
  Modal,
  SecondaryButton,
  DeleteButton,
  CardBody
} from "app/NativeComponents/common";

import { TextButton } from "app/NativeComponents/snippets";

class SavedReplyItem extends Component {
  constructor(props) {
    super(props);

    this.state = {
      show_reply_more: false
    };
  }

  renderMore() {
    if (this.state.show_reply_more) {
      return (
        <ModalOverlay
          isVisible={true}
          onPress={() => {
            this.setState({
              show_reply_more: false
            });
          }}
        >
          <Modal actionSheet>
            <Card
              style={{
                minWidth: "95%",
                paddingBottom: this.props.device == "mobile" ? 10 : 0
              }}
            >
              <CardBody>
                <Title style={{ textAlign: "center" }}>
                  Saved Reply Options
                </Title>
                <Copy style={{ textAlign: "center" }}>Select an option</Copy>
              </CardBody>
              <Card style={{ borderRadius: 30, overflow: "hidden" }}>
                <SecondaryButton
                  onPress={() => {
                    this.props.setEditModal({
                      title: "Edit Saved Reply",
                      description:
                        "Edit reply to be used in other conversations.",
                      slug: "edit-saved-reply",
                      type: "edit_saved_reply",
                      fields: {
                        response_text: this.props.saved_reply.response_text,
                        starting_response: this.props.saved_reply
                          .starting_response
                          ? 1
                          : 0
                      },
                      save_button_text: "Edit Saved Reply",
                      modalAction: ({ fields }) => {
                        this.props.updateSavedResponse({
                          token: this.props.token,
                          type: "update_saved_response",
                          saved_response_id: this.props.saved_reply.id,
                          response_text: fields.response_text,
                          starting_response: fields.starting_response,
                          onSuccess: () => {
                            this.props.appRedirect({
                              redirect: "goBack",
                              payload: { remove: "edit-saved-reply" }
                            });
                          }
                        });
                      },
                      cancelAction: () => {},
                      fieldsUpdated: fields => {}
                    });
                    this.props.appRedirect({
                      redirect: "goForward",
                      payload: { add: "edit-saved-reply" }
                    });
                    this.setState({
                      show_reply_more: false
                    });
                  }}
                >
                  Edit Reply
                </SecondaryButton>
              </Card>

              <Card style={{ borderRadius: 30, overflow: "hidden" }}>
                <DeleteButton
                  onPress={() => {
                    this.props.setModal({
                      title: "Delete Saved Reply",
                      description:
                        "Are you sure you want to delete this saved reply?",
                      icon: "delete",
                      submit: "Delete Saved Reply",
                      buttonType: "destroy",
                      onPress: () => {
                        this.props.updateSavedResponse({
                          token: this.props.token,
                          type: "remove_saved_response",
                          saved_response_id: this.props.saved_reply.id,
                          onSuccess: () => {}
                        });
                      },
                      cancel: "Cancel",
                      onCancel: () => {}
                    });
                    this.props.toggleModal({ show: true, type: "normal" });
                    this.setState({
                      show_reply_more: false
                    });
                  }}
                >
                  Delete Saved Reply
                </DeleteButton>
              </Card>

              <TextButton
                onPress={() => {
                  this.setState({
                    show_reply_more: false
                  });
                }}
                text={"Cancel"}
              />
            </Card>
          </Modal>
        </ModalOverlay>
      );
    }
  }
  renderMultiSendLabel() {
    const { saved_reply, colors } = this.props;
    if (saved_reply.starting_response) {
      return (
        <Wrapper
          style={{
            backgroundColor: colors.background_color,
            borderRadius: 15,
            padding: 3,
            paddingLeft: 10,
            paddingRight: 10,
            marginTop: 5
          }}
        >
          <Copy>Conversation Starter</Copy>
        </Wrapper>
      );
    }
  }

  renderSpamLabel() {
    const { saved_reply, colors } = this.props;
    if (
      saved_reply.spam &&
      saved_reply.starting_response &&
      !saved_reply.spam.valid &&
      saved_reply.spam.phrases &&
      saved_reply.spam.phrases.length > 0
    ) {
      let spam_phrases = "";
      for (let i = 0; i < saved_reply.spam.phrases.length; i++) {
        if (spam_phrases.length == 0) {
          spam_phrases += saved_reply.spam.phrases[i];
        } else {
          spam_phrases += "," + saved_reply.spam.phrases[i];
        }
      }
      return (
        <Wrapper
          style={{
            backgroundColor: colors.yellow_card_color_muted,
            borderRadius: 15,
            padding: 3,
            paddingLeft: 10,
            paddingRight: 10,
            marginTop: 5
          }}
        >
          <Copy>Flagged As Spam (Remove the following: {spam_phrases})</Copy>
        </Wrapper>
      );
    }
  }

  render() {
    const { saved_reply } = this.props;
    if (saved_reply) {
      return (
        <Wrapper>
          <Card>
            <Row style={{ flexWrap: "wrap" }}>
              <Wrapper style={{ flex: 1 }}>
                <Wrapper style={{ padding: 20 }}>
                  <Wrapper>
                    <Copy>{saved_reply.response_text}</Copy>
                  </Wrapper>
                  <Row>
                    {this.renderMultiSendLabel()}
                    {this.renderSpamLabel()}
                  </Row>
                </Wrapper>
              </Wrapper>
              {saved_reply.team != 0 ? (
                <Button
                  style={{
                    width: 50,
                    height: 60,
                    alignItems: "center",
                    justifyContent: "center"
                  }}
                  onPress={() => {
                    this.setState({
                      show_reply_more: true
                    });
                  }}
                >
                  <Icon size={22} icon="more-vert" />
                </Button>
              ) : null}
            </Row>
          </Card>
          {this.renderMore()}
        </Wrapper>
      );
    }
    return <Wrapper />;
  }
}

export default SavedReplyItem;
